const getters = {
  size: (state) => state.app.size,
  meunSettingData: (state) => state.settings.meunSettingData,
  mapSettingData: (state) => state.settings.mapSettingData,
  generalSettingData: (state) => state.settings.generalSettingData,
  alarmReminderChange: (state) => state.settings.alarmReminderChange,
  MGSettingData: (state) => state.settings.MGSettingData,
  videoSettingData: (state) => state.settings.videoSettingData,
  styleSettingData: (state) => state.settings.styleSettingData,

  bigScreenLock: (state) => state.settings.bigScreenLock,
  realtimeSettingData: (state) => state.settings.realtimeSettingData,
  handlerSettingData: (state) => state.settings.handlerSettingDate,

  // 平台设置数据
  MGSettingDefaultData: (state) => state.settings.MGSettingDefault,
  meunSettingDefaultData: (state) => state.settings.meunSettingDefault,
  videoSettingDefaultData: (state) => state.settings.videoSettingDefault,
  mapSettingDefaultData: (state) => state.settings.mapSettingDefault,
  generalSettingDefaultData: (state) => state.settings.generalSettingDefaultData,
  styleSettingDefaultData: (state) => state.settings.styleSettingDefault,
  handlerSettingDefaultData: (state) => state.settings.handlerSettingDefaultData,
  realtimeSettingDefaultData: (state) => state.settings.RealtimeSettingDefault,
  // 实时定位设置的 getter
  realtimeSettingData: (state) =>
    state.settings.realtimeSettingData || state.settings.RealtimeSettingDefault,

  // 设备统计相关的 getters
  deviceStatistics: (state) => state.settings.deviceStatistics,
  totalDevices: (state) => state.settings.deviceStatistics.totalDevices,
  onlineDevices: (state) => state.settings.deviceStatistics.onlineDevices,
  alarmDevices: (state) => state.settings.deviceStatistics.alarmDevices,
  deviceStatsLastUpdate: (state) => state.settings.deviceStatistics.lastUpdate,
  isDeviceStatsLoading: (state) => state.settings.deviceStatistics.isLoading,

  // meunSettingDefault

  menuTagList: (state) => state.settings.menuTagList,

  // V2 权限：禁用的权限 access_code 列表
  disabledPermissions: (state) => state.permission.disabledPermissions || [],

  // V2 菜单定义：从后台 definitions 提取的可导航菜单项列表
  menuDefinitions: (state) => state.permission.menuDefinitions || [],

  // 命令权限相关的 getters（使用 ?? 处理持久化恢复时新字段不存在的情况）
  canSendCommand: (state) => state.permission.canSendCommand ?? true,
  canConfigParam: (state) => state.permission.canConfigParam ?? true,
  canIntercom: (state) => state.permission.canIntercom ?? true,
  canQueryLog: (state) => state.permission.canQueryLog ?? true,
  // 功能权限相关的 getters
  canTrackPlayback: (state) => state.permission.canTrackPlayback ?? true,
  canStatisticalReport: (state) => state.permission.canStatisticalReport ?? true,
  canVideoMonitor: (state) => state.permission.canVideoMonitor ?? true,
  canVideoPlayback: (state) => state.permission.canVideoPlayback ?? true,
  permissionLoaded: (state) => state.permission.permissionLoaded,
  // 菜单加载状态：登录后先为 true，V2 权限加载完成后才为 false
  menuLoading: (state) => state.permission.menuLoading ?? true,
}
export default getters
